import { gql } from 'graphql-request';

export const getPortfolioNatureStatusQuery = gql`
    query GetPortfolioNatureStatus($businessCentralId: String!) {
        organisation(businessCentralId: $businessCentralId) {
            natureStatus {
                content
                createdAt
            }
        }
    }
`;

export type GetPortfolioNatureStatusResult = {
    organisation: {
        natureStatus: {
            content: string;
            createdAt: string;
        } | null;
    } | null;
};

export type SetNatureStatusResponse = {
    content: string;
    createdAt: string;
};
